import { inject, Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';

import type {
  AuthConfirmationSuccessPayload,
  AuthorizeConfirmationPayload,
  SignInPayload,
  SignUpPayload,
} from '../types';

@Injectable({ providedIn: 'root' })
export class CoreHttpService {
  private readonly httpApi = inject(HttpApiService);

  public signIn(payload: SignInPayload): Observable<AuthConfirmationSuccessPayload> {
    return this.httpApi.post('/sign_in', null, payload);
  }

  public logOut(): Observable<void> {
    return this.httpApi.get('/sign_out');
  }

  public signUp(payload: SignUpPayload): Observable<any> {
    return this.httpApi.post('/registration', null, payload);
  }

  public authorizeConfirmation(
    payload: AuthorizeConfirmationPayload,
  ): Observable<AuthConfirmationSuccessPayload> {
    return this.httpApi.post('/registration/authorize_confirmation', null, payload);
  }
}
